import React, { FunctionComponent, useEffect, useState } from 'react';
import { Box, useTheme } from '@material-ui/core';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';
import Translation from '../../../../../../../gqlCommon/components/translation/Translation';
import SummaryLabelWithPrice from '../../summaryLabelWithPrice/SummaryLabelWithPrice';
import { InsuranceTypes } from '../../../../../../enum/InsuranceTypes';
import useWidgetContext from '../../../../../../../common/react/useWidgetContext';
import { insuranceBlockInputStorage } from '../../../../../../../dxpInsuranceBlock/common/service/insuranceBlockInputStorage';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

const SummaryInsurance: FunctionComponent = () => {
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const { loading, selectedCar } = useCustomizeCarContext();
  const [displayInsuranceBlock, setDisplayInsuranceBlock] = useState<boolean>(false);
  const {
    insurance,
    car: { byoCode },
  } = selectedCar;
  const insurancePolicy = insurance?.estimation?.policy;

  const {
    spc: {
      customise: { hideInsuranceQuote },
    },
  } = useTheme<ISpcTheme>();

  useEffect(() => {
    const insuranceBlockStorage = insuranceBlockInputStorage.get(dimensions);
    if (byoCode !== insuranceBlockStorage?.carCode) {
      insuranceBlockInputStorage.clear(dimensions);
      return setDisplayInsuranceBlock(false);
    }
    if (!insurance || hideInsuranceQuote || !insurance?.displayBlock) {
      return setDisplayInsuranceBlock(false);
    }
    setDisplayInsuranceBlock(true);
  }, [byoCode, dimensions, insurance, hideInsuranceQuote]);

  if (!displayInsuranceBlock) {
    return null;
  }

  const getInsuranceTranslation = (type: string) => {
    if (type === InsuranceTypes.ONE) {
      return 'trans__insurance__insurance_quote__insurance_estimate_1yr';
    }

    if (type === InsuranceTypes.TWO) {
      return 'trans__insurance__insurance_quote__insurance_estimate_2yr';
    }

    return 'trans__configurator__customise_page_summary_section__insurance_estimate';
  };

  return (
    <Box data-test="summary:insurance-block">
      {insurancePolicy?.map(insurance => (
        <SummaryLabelWithPrice
          price={insurance.money.amount}
          currency={insurance.money.currency}
          label={<Translation id={getInsuranceTranslation(insurance.type)} />}
          priceType={PriceDisplayType.FINANCE}
          loading={loading}
          testId={`insurance-block:${insurance.type}`}
          key={insurance.type}
        />
      ))}
    </Box>
  );
};

export default SummaryInsurance;
